import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class UtilityServiceService {

  private enableHearingForm: BehaviorSubject<boolean>;
  private filesUploaded: BehaviorSubject<boolean>;
  private user: BehaviorSubject<object>;
  private atozcount: BehaviorSubject<object>;
  private visited: BehaviorSubject<boolean>;
  private search: BehaviorSubject<boolean>;

  constructor(private spinnerService: SpinnerVisibilityService, private authService: MsalService) {
    this.enableHearingForm = new BehaviorSubject<boolean>(false);
    this.filesUploaded = new BehaviorSubject<boolean>(false);
    this.user = new BehaviorSubject<object>({});
    this.atozcount = new BehaviorSubject<object>({});
    this.visited = new  BehaviorSubject<boolean>(false);
    this.search = new  BehaviorSubject<boolean>(false);
  }

  isVisited() {
    return this.visited.asObservable();
  }
  setVisited(newValue: boolean) {
    this.visited.next(newValue);
  }
  public setSearch(newValue: boolean): void {
    this.search.next(newValue);
  }

  public getSearch(): Observable<boolean> {
    return this.search.asObservable();
  }
  // checkLogin() {
  //   var token = localStorage.getItem("msal.idtoken");
  //   if (token) {
  //     token = token.split(".")[1];
  //     token = atob(token);
  //     var json = JSON.parse(token);
  //     var exp = json.exp * 1000;
  //     var current = Date.now();
  //     console.log('exp', exp);
  //     console.log('current', current);
  //     console.log('token on load', token);

  //     if (exp < current) {
  //       this.authService.acquireTokenSilent(['https://mesmartchstsportal.onmicrosoft.com/userimpersonation/user_impersonation'], this.authService.authority, this.authService.getUser()).then(response => {
  //         localStorage.setItem('msal.idtoken', response);
  //       }).catch(error => {
  //         console.log('error in getting silent token', error);
  //         localStorage.clear();
  //         this.authService.loginRedirect();
  //       });
  //     }
  //   }
  // }
  public setEnableHearingForm(newValue: boolean): void {
    console.log(newValue);
    this.enableHearingForm.next(newValue);
  }

  public getEnableHearingForm(): Observable<boolean> {
    return this.enableHearingForm.asObservable();
  }

  public setFilesUploaded(newValue: boolean): void {
    console.log(newValue);
    this.filesUploaded.next(newValue);
  }

  public isFilesUploaded(): Observable<boolean> {
    return this.filesUploaded;
  }
  public setUser(newValue: object): void {
    console.log(newValue);
    this.user.next(newValue);
  }

  public getUser(): Observable<object> {
    return this.user.asObservable();
  }
  public setAtoZCount(newValue: object): void {
    this.atozcount.next(newValue);
  }

  public getAtoZCount(): Observable<object> {
    return this.atozcount.asObservable();
  }
}
